import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  name: string;
  role: 'admin' | 'user';
  // Optional/undefined pre-migration 116 (database/migrations/116_ADD_PROFILE_APPROVAL_STATUS.sql).
  // Treat undefined as 'approved' everywhere — never assume the column exists.
  status?: 'pending' | 'approved' | 'rejected';
  avatar_url?: string;
  preferences?: any;
  created_at: string;
  updated_at: string;
};

export type Institution = {
  id: string;
  code: string;
  name: string;
  full_name: string;
  description?: string;
  website_url?: string;
  logo_url?: string;
  primary_color: string;
  secondary_color: string;
  document_types: string[];
  enabled: boolean;
  sort_order: number;
  metadata?: any;
  created_at: string;
  updated_at: string;
};

export type InstitutionStats = {
  code: string;
  name: string;
  full_name: string;
  total_documents: number;
  documents_last_month: number;
  documents_last_week: number;
  last_document_date?: string;
  documents_by_type?: Record<string, number>;
};

export type Document = {
  id: string;
  document_id: string;
  institution_code: string;
  tipo: string; // Institution-specific document type
  subtipo?: string; // Optional subtype (e.g., 'renta', 'iva' for SII oficios)
  year: number;
  numero: string;
  fecha_publicacion: string | null;
  fecha_emision?: string | null;
  titulo: string;
  resumen: string;
  ai_summary?: string; // JSON-structured AI summary
  contenido_extraido?: string; // Extracted PDF text
  articulos_relevantes?: string[]; // NEW: Legal article references
  pdf_url?: string; // Legacy field
  source_url: string; // R2/Supabase Storage URL
  storage_path?: string; // Legacy field
  file_hash?: string; // SHA-256 hash for duplicate detection
  metadata?: any;
  source?: string;
  created_at: string;
  updated_at?: string;
  is_favorite?: boolean;
  // Legacy support (materia is now subtipo)
  materia?: string;
  // Search relevance scores (only present in hybrid search results)
  scores?: {
    semantic: number;
    lexical: number;
    combined: number;
  };
};

export type Favorite = {
  id: string;
  user_id: string;
  document_id: string;
  created_at: string;
};

export type ScraperLog = {
  id: string;
  institution_code: string;
  tipo: string;
  year: number;
  subtipo?: string | null; // Renamed from materia
  status: 'running' | 'completed' | 'failed' | 'stopped';
  documents_found: number;
  documents_processed: number;
  documents_new: number;
  error_message?: string | null;
  started_at: string;
  completed_at?: string | null;
  metadata?: any;
  // Legacy support
  materia?: string | null;
};

export type AlertLog = {
  id: string;
  documents_count: number;
  users_notified: number;
  users_failed: number;
  document_types: string[];
  metadata?: any;
  created_at: string;
};
